import React from "react";
import { Search, X } from "lucide-react";
import { cn } from "../utils";
import { Panel } from "../panel";
import { RaboInput } from "../rabo-input";

export function SearchInput({ value, onChange, placeholder, className, inputClassName }) {
  return (
    <div className={cn("relative flex-1", className)}>
      <Search className="w-4 h-4 text-gray-400 absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none" />
      <RaboInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn("pl-10 pr-10", inputClassName)}
        style={{ fontSize: "0.85rem" }}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

export function FilterBar({ children, className }) {
  return (
    <Panel rounded="sm" shadow padding="sm" className={className}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">{children}</div>
    </Panel>
  );
}

/** Flat toolbar for dashboards — no card wrapper */
export function PageToolbar({ children, className }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pb-4 mb-2 border-b border-gray-200/70",
        className
      )}
    >
      {children}
    </div>
  );
}

export function SegmentToggle({ items, value, onChange, labelFn, className }) {
  return (
    <div className={cn("inline-flex items-center gap-1 rounded-lg bg-gray-100/80 p-1", className)}>
      {items.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={cn(
            "px-3 py-1.5 rounded-md text-sm transition-all whitespace-nowrap",
            value === item
              ? "bg-white text-gray-900 shadow-sm font-medium"
              : "text-gray-500 hover:text-gray-700"
          )}
        >
          {labelFn ? labelFn(item) : item}
        </button>
      ))}
    </div>
  );
}

export function ViewToggle({ value, onChange, options }) {
  return (
    <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden flex-shrink-0">
      {options.map(({ id, icon: Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          className={cn(
            "p-2 transition-colors",
            value === id ? "bg-gray-900 text-white" : "bg-white text-gray-400 hover:text-gray-600"
          )}
        >
          <Icon className="w-4 h-4" />
        </button>
      ))}
    </div>
  );
}
